function useStateContextCallbacks() {
    return {
        updateGcmConsentTypeChecked: ({ gcmConsent }, type, checked)=>{
        /* Silence is golden... Until you have PRO Version! */ }
    };
}
export { useStateContextCallbacks };
